import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './grid.module.scss'

export const Grid = ({ children, className }) => {
  const classes = classNames(styles.el, className)
  return <div className={classes}>{children}</div>
}

Grid.defaultProps = {
  children: undefined,
  className: '',
}

Grid.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}
